// const { createRoot } = ReactDOM;
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Dropdown, Form, Input, Table } from "antd";

import { DndContext } from "@dnd-kit/core";
import {
	arrayMove,
	SortableContext,
	useSortable,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Swal from "sweetalert2";

const EditableContext = React.createContext(null);
// const EditableRow = ({ index, ...props }) => {
// 	const [form] = Form.useForm();
// 	return (
// 		<Form form={form} component={false}>
// 			<EditableContext.Provider value={form}>
// 				<tr {...props} />
// 			</EditableContext.Provider>
// 		</Form>
// 	);
// };
const EditableDraggableRow = ({ children, ...props }) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		setActivatorNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({
		id: props["data-row-key"],
	});
	const [form] = Form.useForm();
	const style = {
		...props.style,
		transform: CSS.Transform.toString(
			transform && {
				...transform,
				scaleY: 1,
			}
		)?.replace(/translate3d\(([^,]+),/, "translate3d(0,"),
		transition,
		...(isDragging
			? {
					position: "relative",
					zIndex: 1,
			  }
			: {}),
	};
	return (
		<Form form={form} component={false}>
			<EditableContext.Provider value={form}>
				<tr {...props} ref={setNodeRef} style={style} {...attributes}>
					{React.Children?.map(children, (child) => {
						if (child.key === "sort") {
							return React.cloneElement(child, {
								children: (
									<img
										src={`/assets/images/hamburger-icon-gray.png`}
										alt={`햄버그 아이콘`}
										style={{
											width: "1.5em",
											height: "auto",
											cursor: "pointer",
											touchAction: "none",
										}}
										ref={setActivatorNodeRef}
										{...listeners}
									/>
								),
							});
						}
						return child;
					})}
				</tr>
				{/*<tr {...props} />*/}
			</EditableContext.Provider>
		</Form>
	);
};
const EditableCell = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	...restProps
}) => {
	const isLoading = useSelector((state) => state.common.loading);
	const [editing, setEditing] = useState(false);
	const inputRef = useRef(null);
	const form = useContext(EditableContext);
	useEffect(() => {
		if (editing) {
			inputRef.current.focus();
		}
	}, [editing]);
	const toggleEdit = () => {
		setEditing(!editing);
		form.setFieldsValue({
			[dataIndex]: record[dataIndex],
		});
	};
	const save = async () => {
		try {
			const values = await form.validateFields();
			toggleEdit();
			handleSave({
				...record,
				...values,
			});
		} catch (errInfo) {
			console.log("Save failed:", errInfo);
		}
	};
	let childNode = children;
	if (editable) {
		childNode = editing ? (
			<Form.Item
				style={{
					margin: 0,
				}}
				name={dataIndex}
				// rules={[
				//     {
				//         required: true,
				//         message: `${title} is required.`,
				//     },
				// ]}
			>
				<Input ref={inputRef} onPressEnter={save} onBlur={save} />
			</Form.Item>
		) : (
			<Button
				className="ant-input"
				style={{
					textAlign: "left",
					cursor: "text",
					minWidth: "100%",
					visibility: "visible",
					overflow: "hidden",
				}}
				onClick={toggleEdit}
				loading={isLoading}
			>
				{children}
			</Button>
			// <Input value={children} />
		);
	}
	return <td {...restProps}>{childNode}</td>;
};

const EditFaqTable = ({ dataSource, setDataSource, dropdownCategory }) => {
	const isLoading = useSelector((state) => state.common.loading);
	const [count, setCount] = useState(
		dataSource?.length ? dataSource.length : 0
	);

	const handleDelete = (record) => {
		let name = record?.ingredient_name;
		Swal.fire({
			customClass: "alert-custom",
			text: `${name ? name : "해당"} 성분을 정말로 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				const newData = dataSource?.filter((item) => item.key !== record.key);
				setDataSource(newData);
			}
		});
	};

	const defaultColumns = [
		{
			key: "sort",
			width: 40,
		},
		{
			title: "순서",
			dataIndex: "",
			key: "",
			ellipsis: true,
			width: 80,
			align: "center",
			render: (value, item, idx) => {
				return (
					<p className={`order-number`}>
						{idx > 10 ? idx + 1 : "0" + (idx + 1)}
					</p>
				);
			},
		},
		{
			title: "성분명",
			dataIndex: "ingredient_name",
			key: "ingredient_name",
			ellipsis: true,
			width: 180,
			align: "center",
			render: (value, record, idx) => {
				return (
					<Dropdown
						overlay={() => dropdownCategory(idx)}
						trigger={["click"]}
						overlayStyle={{
							maxHeight: "15em",
							border: "solid 1px #ced4da",
							overflow: "auto",
						}}
					>
						<Button
							style={{
								display: "flex",
								alignItems: "center",
								gap: "3px",
								padding: "4px 11px",
								width: "100%",
								justifyContent: "space-between",
								overflow: "hidden",
							}}
							loading={isLoading}
						>
							{value ? value : "성분을 선택해주세요"}
							<img
								src={`/assets/images/report/report-search-date-icon-down.png`}
								alt={`드롭다운`}
								style={{
									height: "auto",
									width: "0.8em",
								}}
							/>
						</Button>
					</Dropdown>
				);
			},
		},
		{
			title: "성분설명",
			dataIndex: "explanation",
			// width: '30%',
			editable: true,
			align: "center",
		},
		{
			title: "삭제",
			dataIndex: "",
			width: 80,
			align: "center",
			render: (_, record) =>
				dataSource.length >= 1 ? (
					// <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
					//     <a>Delete</a>
					// </Popconfirm>
					<Button size={`small`} onClick={() => handleDelete(record)}>
						삭제
					</Button>
				) : null,
		},
	];

	const onDragEnd = ({ active, over }) => {
		if (active?.id !== over?.id) {
			setDataSource((previous) => {
				const activeIndex = previous.findIndex((i) => i.id === active?.id);
				const overIndex = previous.findIndex((i) => i.id === over?.id);
				return arrayMove(previous, activeIndex, overIndex);
			});
		}
	};
	const handleAdd = () => {
		const newData = {
			key: count,
			// ingredient_name: `Edward King ${count}`,
			// explanation: `Edward queen ${count}`,
			// address: `London, Park Lane no. ${count}`,
		};
		if (dataSource) {
			setDataSource([...dataSource, newData]);
			setCount(count + 1);
		} else {
			setDataSource([newData]);
			setCount(count + 1);
		}
	};

	const handleSave = (row) => {
		const newData = [...dataSource];
		const index = newData.findIndex((item) => row.key === item.key);
		const item = newData[index];
		newData.splice(index, 1, {
			...item,
			...row,
		});
		setDataSource(newData);
	};

	const components = {
		body: {
			row: EditableDraggableRow,
			// EditableRow,
			cell: EditableCell,
		},
	};
	const columns = defaultColumns.map((col) => {
		if (!col.editable) {
			return col;
		}
		return {
			...col,
			onCell: (record) => ({
				record,
				editable: col.editable,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave,
			}),
		};
	});

	return (
		<div>
			{dataSource?.length ? (
				<DndContext onDragEnd={onDragEnd}>
					<SortableContext
						// rowKey array
						items={dataSource?.map((i) => i?.id)}
						strategy={verticalListSortingStrategy}
					>
						<Table
							className={`channel-edit-table`}
							components={components}
							dataSource={dataSource}
							rowClassName={() => "editable-row"}
							rowKey="id"
							size={`small`}
							bordered
							columns={columns}
							pagination={false}
						/>
					</SortableContext>
				</DndContext>
			) : (
				<Table
					className={`channel-edit-table`}
					components={components}
					dataSource={dataSource}
					rowClassName={() => "editable-row"}
					rowKey="id"
					size={`small`}
					bordered
					columns={columns}
					pagination={false}
				/>
			)}

			<Button
				size={"small"}
				className={`edit-gray-btn`}
				style={{
					// borderRadius: "5px",
					// width: "50%",
					margin: "1em auto",
					padding: "0.3em 1.5em",
					height: "auto",
				}}
				loading={isLoading}
				onClick={handleAdd}
			>
				<img
					src={`/assets/images/channel/plus-circle.png`}
					alt={`관련 성분 추가하기`}
					style={{
						width: "auto",
						height: "1em",
					}}
				/>
				관련 성분 추가하기
			</Button>
		</div>
	);
};
export default EditFaqTable;
